import { injectable } from 'inversify';
import { action, computed, makeObservable, observable } from 'mobx';
import type { ThemeName } from '@/assets/branding/interfaces.ts';

@injectable()
export class ThemeStore {
  @observable
  private _theme: ThemeName = 'light';

  public constructor() {
    makeObservable(this);
  }

  @computed
  public get theme(): ThemeName {
    return this._theme;
  }

  @action
  public setTheme(theme: ThemeName): void {
    this._theme = theme;
  }
}
